import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import api from '../services/api';
import {
  Pane,
  TextInputField,
  Button,
  Heading,
  toaster
} from 'evergreen-ui';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await login({
        username: email,
        password: password
      });
      
      toaster.success('Login successful!');
      navigate('/dashboard');
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || 'Login failed';
      toaster.danger(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Pane
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      background="tint2"
    >
      <Pane
        elevation={1}
        background="white"
        padding={40}
        width={400}
        borderRadius={8}
      >
        <Heading size={700} marginBottom={20} textAlign="center">
          Login
        </Heading>
        <form onSubmit={handleSubmit}>
          <TextInputField
            label="Email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
            required
          />
          <TextInputField
            label="Password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
            required
          />
          <Button
            appearance="primary"
            type="submit"
            width="100%"
            height={40}
            marginTop={16}
            isLoading={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Log In'}
          </Button>
        </form>
        <Pane 
          textAlign="center" 
          marginTop={16} 
          display="flex" 
          justifyContent="center" 
          gap={8}
        >
          <span>Don't have an account?</span>
          <Link 
            to="/signup" 
            style={{ 
              color: '#1070CA',
              textDecoration: 'none'
            }}
          >
            Sign up
          </Link>
        </Pane>
      </Pane>
    </Pane>
  );
};

export default Login;
